<template>
  <div>
    <PageAllow controller="Suppliers" action="criteriaSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <v-card>
          <v-card-title>
            {{ $t("SupplierCriteriaSetting.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <!-- 供应商评分标准分数 -->
            <v-row align="center">
              <v-col cols="6">
                <span class="font-weight-bold">
                  {{ $t("SupplierCriteriaSetting.supplierCriteriaScores.title") }}
                </span>
                <br />
                <span class="font-weight-bold red--text">
                    {{ $t("SupplierCriteriaSetting.supplierCriteriaScores.hint") }}
                </span>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierCriteriaScores.satisfaction_rate") }}
                  </v-col>
                  <v-col cols="8" md="7">
                    <v-text-field single-line v-model="supplier_scoring_criteria.satisfaction_score"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierCriteriaScores.qualification_rat") }}
                  </v-col>
                  <v-col cols="8" md="7">
                    <v-text-field single-line v-model="supplier_scoring_criteria.qualification_score"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierCriteriaScores.timeliness_rate") }}
                  </v-col>
                  <v-col cols="8" md="7">
                    <v-text-field single-line v-model="supplier_scoring_criteria.timeliness_score"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierCriteriaScores.price_fluctuation_num") }}
                  </v-col>
                  <v-col cols="8" md="7">
                    <v-text-field single-line v-model="supplier_scoring_criteria.price_fluctuation_score"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierCriteriaScores.artificial") }}
                  </v-col>
                  <v-col cols="8" md="7">
                    <v-text-field
                      single-line
                      v-model="supplier_scoring_criteria.artificial_score"
                      persistent-hint
                      :hint="$t('SupplierCriteriaSetting.supplierCriteriaScores.artificial_hint')"
                    >
                    </v-text-field>

                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6">
                <div id="chartLineBox" style="height: 45vh"></div>
              </v-col>
            </v-row>
            <v-divider />
            <!-- 供应商等级划分 -->
            <v-row align="center" class="mt-5">
              <v-col cols="12">
                <span class="font-weight-bold">
                  {{ $t("SupplierCriteriaSetting.supplierClassification.title") }}
                  <v-chip
                    color="primary"
                    label
                    small
                    class="ml-10"
                  >
                    {{ $t("SupplierCriteriaSetting.supplierClassification.A") }}
                  </v-chip>
                  <v-chip
                    color="orange"
                    dark
                    label
                    small
                    class="ml-10 white--text"
                   >
                    {{ $t("SupplierCriteriaSetting.supplierClassification.B") }}
                  </v-chip>
                  <v-chip
                    color="accent"
                    label
                    small
                    class="ml-10"
                   >
                    {{ $t("SupplierCriteriaSetting.supplierClassification.C") }}
                  </v-chip>
                  <v-chip
                    color="danger"
                    label
                    small
                    class="ml-10 white--text"
                   >
                    {{ $t("SupplierCriteriaSetting.supplierClassification.D") }}
                  </v-chip>
                </span>
                <br />
                <span class="font-weight-bold red--text">
                  {{ $t("SupplierCriteriaSetting.supplierClassification.hint") }}
                </span>
              </v-col>
              <v-col cols="6">
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierClassification.A") }}
                  </v-col>
                  <v-col cols="2">
                    <span>{{ $t("SupplierCriteriaSetting.input") }}<v-icon x-small class="pe-1">fa-greater-than</v-icon></span>
                    <v-text-field single-line v-model="supplier_criteria_setting.supplier_level.A.start" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                  <v-col cols="2" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="2">
                    <span><v-icon x-small class="pe-1">fa-less-than-equal</v-icon>{{ $t("SupplierCriteriaSetting.input") }}</span>
                    <v-text-field single-line v-model="supplier_criteria_setting.supplier_level.A.end" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierClassification.B") }}
                  </v-col>
                  <v-col cols="2">
                    <v-text-field single-line v-model="supplier_criteria_setting.supplier_level.B.start" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                  <v-col cols="2" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="2">
                    <v-text-field single-line v-model="supplier_criteria_setting.supplier_level.B.end" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierClassification.C") }}
                  </v-col>
                  <v-col cols="2">
                    <v-text-field single-line v-model="supplier_criteria_setting.supplier_level.C.start" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                  <v-col cols="2" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="2">
                    <v-text-field single-line v-model="supplier_criteria_setting.supplier_level.C.end" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.supplierClassification.D") }}
                  </v-col>
                  <v-col cols="4">
                  </v-col>
                  <v-col cols="2">
                    <v-text-field single-line v-model="supplier_criteria_setting.supplier_level.D.end" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                  <v-col cols="2" class="font-weight-bold text-left">
                    {{ $t("SupplierCriteriaSetting.cutOff") }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider />
            <!-- 订单满足率 -->
            <v-row align="center" class="mt-5">
              <v-col cols="12">
                <span class="font-weight-bold">
                   {{ $t("SupplierCriteriaSetting.satisfactionRate.title", [supplier_scoring_criteria.satisfaction_score]) }}
                </span>
                <br />
                <span class="font-weight-bold red--text">
                  {{ $t("SupplierCriteriaSetting.satisfactionRate.hint", [supplier_scoring_criteria.satisfaction_score]) }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.satisfactionRate.title2") }}
                  </v-col>
                  <v-col cols="1">
                     <span>{{ $t("SupplierCriteriaSetting.input") }}<v-icon x-small class="pe-1">fa-greater-than</v-icon></span>
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.A.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <span><v-icon x-small class="pe-1">fa-less-than-equal</v-icon>{{ $t("SupplierCriteriaSetting.input") }}</span>
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.A.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.scores") }}
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.A.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.B.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.B.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.B.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.C.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.C.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.C.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.D.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-left">
                    {{ $t("SupplierCriteriaSetting.cutOff") }}
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.satisfaction_score_criteria.D.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider />
            <!-- 质量合格率 -->
            <v-row align="center" class="mt-5">
              <v-col cols="12">
                <span class="font-weight-bold">
                   {{ $t("SupplierCriteriaSetting.qualificationRate.title", [supplier_scoring_criteria.qualification_score]) }}
                </span>
                <br />
                <span class="font-weight-bold red--text">
                   {{ $t("SupplierCriteriaSetting.qualificationRate.hint", [supplier_scoring_criteria.qualification_score]) }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.qualificationRate.title2") }}
                  </v-col>
                  <v-col cols="1">
                    <span>{{ $t("SupplierCriteriaSetting.input") }}<v-icon x-small class="pe-1">fa-greater-than</v-icon></span>
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.A.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <span>
                      <span><v-icon x-small class="pe-1">fa-less-than-equal</v-icon>{{ $t("SupplierCriteriaSetting.input") }}</span>
                    </span>
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.A.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.scores") }}
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.A.score"  :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.B.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.B.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.B.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.C.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.C.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.C.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.D.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-left">
                    {{ $t("SupplierCriteriaSetting.cutOff") }}
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.qualification_score_criteria.D.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider />
            <!-- 到货及时率 -->
            <v-row align="center" class="mt-5">
              <v-col cols="12">
                <span class="font-weight-bold">
                   {{ $t("SupplierCriteriaSetting.timelinessRate.title", [supplier_scoring_criteria.timeliness_score]) }}
                </span>
                <br />
                <span class="font-weight-bold red--text">
                   {{ $t("SupplierCriteriaSetting.timelinessRate.hint", [supplier_scoring_criteria.timeliness_score]) }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.timelinessRate.title2") }}
                  </v-col>
                  <v-col cols="1">
                    <span>{{ $t("SupplierCriteriaSetting.input") }}<v-icon x-small class="pe-1">fa-greater-than</v-icon></span>
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.A.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <span><v-icon x-small class="pe-1">fa-less-than-equal</v-icon>{{ $t("SupplierCriteriaSetting.input") }}</span>
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.A.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.scores") }}
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.A.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.B.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.B.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.B.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.C.start" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.C.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.C.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="4"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.D.end" suffix="%"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-left">
                    {{ $t("SupplierCriteriaSetting.cutOff") }}
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.timeliness_score_criteria.D.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider />
            <!-- 价格负向波动 -->
            <v-row align="center" class="mt-5">
              <v-col cols="12">
                <span class="font-weight-bold">
                   {{ $t("SupplierCriteriaSetting.priceFluctuationScore.title", [supplier_scoring_criteria.price_fluctuation_score]) }}
                </span>
                <br />
                <span class="font-weight-bold red--text">
                   {{ $t("SupplierCriteriaSetting.priceFluctuationScore.hint", [supplier_scoring_criteria.price_fluctuation_score]) }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.priceFluctuationScore.title2") }}
                  </v-col>
                  <v-col cols="1">
                    <span>{{ $t("SupplierCriteriaSetting.input") }}<v-icon x-small class="pe-1">fa-greater-than-equal</v-icon></span>
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.A.start" :suffix="$t('Global.times')"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <span>
                      <span><v-icon x-small class="pe-1">fa-less-than</v-icon>{{ $t("SupplierCriteriaSetting.input") }}</span>
                    </span>
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.A.end" :suffix="$t('Global.times')"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                    {{ $t("SupplierCriteriaSetting.scores") }}
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.A.score"  :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2" class="font-weight-bold text-right"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.B.start" :suffix="$t('Global.times')"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-center">
                    ~
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.B.end" :suffix="$t('Global.times')"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-right">
                  </v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.B.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="2"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.C.start" :suffix="$t('Global.times')"></v-text-field>
                  </v-col>
                  <v-col cols="1" class="font-weight-bold text-left">
                    {{ $t("SupplierCriteriaSetting.cutOn") }}
                  </v-col>
                  <v-col cols="2"></v-col>
                  <v-col cols="1">
                    <v-text-field single-line v-model="supplier_criteria_setting.price_fluctuation_score_criteria.C.score" :suffix="$t('Global.score')"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider />
            <v-divider />
          </v-card-text>
        </v-card>
      </v-sheet>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click.stop="$router.push('/supplier')"
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$t("SupplierDetail.ObjectName")]) }}
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn color="success" block @click="save()">
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Suppliers from "@/api/suppliers";

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.purchases"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("Nav.supplier"),
        disabled: false,
        href: "/supplier",
      },
      {
        text: i18n.t("SupplierCriteriaSetting.title"),
        disabled: true,
      }
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    chartLine: null,
    supplier_criteria_setting: {
      supplier_scoring_criteria: {

      },
      supplier_level: {
        A: {
          start: '',
          end: '',
        },
        B: {
          start: '',
          end: '',
        },
        C: {
          start: '',
          end: '',
        },
        D: {
          end: '',
        },
      },
      satisfaction_score_criteria: {
        A: {
          start: '',
          end: '',
          score: '',
        },
        B: {
          start: '',
          end: '',
          score: '',
        },
        C: {
          start: '',
          end: '',
          score: '',
        },
        D: {
          end: '',
          score: '',
        },
      },
      timeliness_score_criteria: {
        A: {
          start: '',
          end: '',
          score: '',
        },
        B: {
          start: '',
          end: '',
          score: '',
        },
        C: {
          start: '',
          end: '',
          score: '',
        },
        D: {
          end: '',
          score: '',
        },
      },
      qualification_score_criteria: {
        A: {
          start: '',
          end: '',
          score: '',
        },
        B: {
          start: '',
          end: '',
          score: '',
        },
        C: {
          start: '',
          end: '',
          score: '',
        },
        D: {
          end: '',
          score: '',
        },
      },
      price_fluctuation_score_criteria: {
        A: {
          start: '',
          end: '',
          score: '',
        },
        B: {
          start: '',
          end: '',
          score: '',
        },
        C: {
          start: '',
          score: '',
        },
      }
    },
    supplier_scoring_criteria: {
      satisfaction_score: '',
      qualification_score: '',
      timeliness_score: '',
      price_fluctuation_score: '',
      artificial_score: ''
    }
  }),

  mounted() {
    this.itemsLoading = true;
    Suppliers.getCriteriaSetting().then(
            function (response) {
              if (response.data.status.isOK()) {
                if (response.data.supplier_criteria_setting) {
                  this.supplier_criteria_setting = response.data.supplier_criteria_setting
                  this.supplier_scoring_criteria = response.data.supplier_criteria_setting.supplier_scoring_criteria
                }
                this.drawLineChart();
              }
              this.itemsLoading = false;
            }.bind(this)
    );
  },

  methods: {
    drawLineChart() {
      if (this.chartLine != null && this.chartLine != "" && this.chartLine != undefined) {
        this.chartLine.dispose();//销毁
      }
      this.chartLine = echarts.init(document.getElementById("chartLineBox"));

      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '90%',
          left: 'center'
        },
        series: [
          {
            type: 'pie',
            radius: ['35%', '50%'],
            // color: ['#BE680A', '#FF6D22', '#009688', '#609FDC', '#FF9886'],
            labelLine: {
              show: true,
            },
            label:{
              formatter: '{b}: {c}分'
            },
            data: [
              { value: this.supplier_scoring_criteria.satisfaction_score, name: i18n.t("SupplierCriteriaSetting.supplierCriteriaScores.satisfaction_rate") },
              { value: this.supplier_scoring_criteria.qualification_score, name: i18n.t("SupplierCriteriaSetting.supplierCriteriaScores.qualification_rat") },
              { value: this.supplier_scoring_criteria.timeliness_score, name: i18n.t("SupplierCriteriaSetting.supplierCriteriaScores.timeliness_rate") },
              { value: this.supplier_scoring_criteria.price_fluctuation_score, name: i18n.t("SupplierCriteriaSetting.supplierCriteriaScores.price_fluctuation_num") },
              { value: this.supplier_scoring_criteria.artificial_score, name: i18n.t("SupplierCriteriaSetting.supplierCriteriaScores.artificial") }
            ]
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
    save() {
      this.supplier_criteria_setting.supplier_scoring_criteria = this.supplier_scoring_criteria
      Suppliers.saveCriteriaSetting(this.supplier_criteria_setting).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("SupplierCriteriaSetting.Messages.saveSuccess"));
            this.$router.push('/supplier')
          }
        }.bind(this)
      )
    }
  },

  watch: {
    supplier_scoring_criteria: {
      deep: true,
      handler() {
        this.drawLineChart();
      },
    }
  },
};
</script>